import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faBed, faBath, faPhone, faGlobe } from '@fortawesome/free-solid-svg-icons';
import NavbarV2 from '../global-components/navbar-v2';
import './AgentList.css';

const AgentProperties = () => {
  const params = useParams();
  const navigate = useNavigate();

  // Correction : logiquement, tu traites agentId ici, pas dans une fonction utilitaire
  let agentId = params.agentId;

  // Si agentId est malformé (cas QR code mobile), corrige ici :
  if (agentId && agentId.includes('#/agent-properties/')) {
    const parts = agentId.split('/');
    agentId = parts[parts.length - 1];
  }

  const [properties, setProperties] = useState([]);
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!agentId) {
      setError("L'identifiant de l'agent est invalide.");
      setLoading(false);
      return;
    }
    const fetchAgentData = async () => {
      try {
        // Récupérer les infos du courtier
        const agentResponse = await axios.get(`https://keurgui-backend-kjour.ondigitalocean.app/api/agents/${agentId}`);
        setAgent(agentResponse.data);

        // Récupérer les propriétés du courtier
        const propertiesResponse = await axios.get(`https://keurgui-backend-kjour.ondigitalocean.app/api/products/agent/${agentId}`);
        setProperties(propertiesResponse.data.products);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchAgentData();
  }, [agentId]);

  if (loading) {
    return <p>Chargement...</p>;
  }

  if (error) {
    return <p style={{ textAlign: "center", color: "red" }}>Erreur: {error}</p>;
  }

  return (
    <>
      {/* Intégration de la Navbar */}
      <NavbarV2 />

      <div className="container">
        <div className="ltn-author-introducing clearfix">
         <div className="author-img">
  <img
    src={
      agent?.photoProfil
        ? agent.photoProfil // l'URL complète déjà stockée dans MongoDB
        : "/assets/img/blog/author.jpg" // fallback si pas d'image
    }
    alt={agent?.agentName || "Photo de l'agent"}
    onError={(e) => {
      e.target.src = "/assets/img/blog/author.jpg"; // fallback si l'image DigitalOcean ne charge pas
    }}
  />
</div>
          <div className="author-info">
            <h6>Agent Immobilier</h6>
            <h2>{agent ? agent.agentName : "Nom inconnu"}</h2>
            <div className="footer-address">
              <ul>
                <li>
                  <div className="footer-address-icon">
                    <i className="icon-placeholder" />
                  </div>
                  <div className="footer-address-info">
                    <p>{agent ? agent.territoire : "Localisation inconnue"}</p>
                  </div>
                </li>
                <li>
                  <div className="footer-address-icon">
                    <i className="icon-call" />
                  </div>
                  <div className="footer-address-info">
                    <p>
                      <a href={`tel:${agent ? agent.phoneNumber : "+000-000000"}`}>
                        {agent ? agent.phoneNumber : "Numéro inconnu"}
                      </a>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="footer-address-icon">
                    <i className="icon-mail" />
                  </div>
                  <div className="footer-address-info">
                    <p>
                      <a href={`mailto:${agent ? agent.email : "example@example.com"}`}>
                        {agent ? agent.email : "Email inconnu"}
                      </a>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Section du Courtier */}
        {agent && (
          <div className="ltn-author-introducing clearfix">
            <div className="">
              {/* Espace réservé */}
            </div>
            {/* Informations supplémentaires */}
            <div className="agent-extra">
              <div>
                <h6>Information complémentaire</h6>
                <p>Parle {agent.langue}</p>
                <p>Détient une assurance responsabilité professionnelle</p>
              </div>
              <div>
                <h6>Territoire desservi</h6>
                <p>{agent.territoire}</p>
              </div>
            </div>
          </div>
        )}

        {/* Liste des propriétés */}
        <h4 className="property-title">Propriétés du courtier</h4>
        <div className="row">
          {properties.length > 0 ? (
            properties.map((product) => (
              <div key={product._id} className="col-lg-3 col-sm-6 col-12">
                <img
                  src={product.images?.[0] || "/path/to/default-image.jpg"}
                  alt={product.title}
                  className="property-image"
                  onClick={() => navigate(`/product/${product._id}`)}
                />
                {/* Détails de la propriété */}
                <div className="property-details">
                  <h6>{product.price?.toLocaleString()} FCfa</h6>
                  <h6>{product.title}</h6>
                  <p>{product.address}, {product.city}</p>
                  <div className="property-features">
                    <span>
                      <FontAwesomeIcon icon={faBed} className="fa-bed" /> {product.features?.bedrooms || 0}
                    </span>
                    <span>
                      <FontAwesomeIcon icon={faBath} className="fa-bath" /> {product.features?.bathrooms || 0}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", color: "red", fontSize: "18px", marginTop: "20px" }}>
              ❌ Aucune propriété disponible pour cet agent.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default AgentProperties;